<template>
  <div v-if="ready">
    <b-row>
      <b-col>
        <b-input-group size="sm" prepend="Exportadora" class="mt-3">
          <v-2-select
            size="small"
            ref="company_select"
            v-if="clientCustomerOptions.length > 0"
            :options="clientCustomerOptions"
            v-model="$v.form.documentClientCustomer.$model"
            :state="$v.form.documentClientCustomer.$dirty ? !$v.form.documentClientCustomer.$error : null"
          >
          </v-2-select>
        </b-input-group>
        <b-input-group size="sm" prepend="Emisor del documento" class="mt-3">
          <v-2-select
            size="small"
            ref="company_select"
            v-if="senderOptions.length > 0"
            :options="senderOptions"
            v-model="$v.form.documentSenderCompany.$model"
            :state="$v.form.documentSenderCompany.$dirty ? !$v.form.documentSenderCompany.$error : null"
          >
          </v-2-select>
        </b-input-group>
        <b-input-group size="sm" prepend="Receptor del documento" class="mt-3">
          <v-2-select
            size="small"
            ref="company_select"
            v-if="receiverOptions.length > 0"
            :options="receiverOptions"
            v-model="$v.form.documentRecipientCompany.$model"
            :state="$v.form.documentRecipientCompany.$dirty ? !$v.form.documentRecipientCompany.$error : null"
          >
          </v-2-select>
        </b-input-group>

        <b-input-group size="sm" prepend="Sucursal" class="mt-3">
          <b-form-select
            size="sm"
            v-model="$v.form.sucursal.$model"
            :state="$v.form.sucursal.$dirty ? !$v.form.sucursal.$error : null"
            :options="sucursalOptions"
          ></b-form-select>
          <b-input-group-append>
            <b-button
              variant="outline-primary"
              @click.prevent="$bvModal.show('create-sucursal-modal')"
              :disabled="!form.documentRecipientCompany"
              ><i class="fa fa-plus"></i
            ></b-button>
          </b-input-group-append>
        </b-input-group>
        <create-sucursal
          id="create-sucursal-modal"
          :company-id="form.documentRecipientCompany ? form.documentRecipientCompany.id : null"
          @success="handleSucursalSuccess"
        />
        <span v-if="form.sucursal"
          ><small> {{ form.sucursal.address }}, {{ form.sucursal.city }}, {{ form.sucursal.township }} </small></span
        >
      </b-col>
      <b-col>
        <b-input-group size="sm" prepend="Nº Documento/Guía" class="mt-3">
          <b-form-input
            autocomplete="off"
            type="text"
            size="sm"
            v-model="$v.form.documentNumber.$model"
            :state="$v.form.documentNumber.$dirty ? !$v.form.documentNumber.$error : null"
            id="name"
            placeholder="Ingrese el número de documento"
          />
        </b-input-group>

        <b-input-group size="sm" prepend="Fecha de emision" class="mt-3">
          <b-form-input
            autocomplete="off"
            type="date"
            size="sm"
            v-model="$v.form.documentDate.$model"
            :state="$v.form.documentDate.$dirty ? !$v.form.documentDate.$error : null"
            id="name"
            placeholder="Ingrese la fecha de emisión"
          />
        </b-input-group>
        <b-input-group size="sm" prepend="Fecha de llegada" class="mt-3">
          <b-form-input
            autocomplete="off"
            type="date"
            size="sm"
            v-model="$v.form.documentArrivalDatetime.$model"
            :state="$v.form.documentArrivalDatetime.$dirty ? !$v.form.documentArrivalDatetime.$error : null"
            id="name"
            placeholder="Ingrese la fecha de llegada"
          />
        </b-input-group>
      </b-col>
      <b-col>
        <b-input-group size="sm" prepend="Despacho" class="mt-3">
          <b-form-select
            size="sm"
            v-model="$v.form.despacho.$model"
            :state="$v.form.despacho.$dirty ? !$v.form.despacho.$error : null"
            :options="despachoOptions"
          ></b-form-select>
        </b-input-group>
        <b-input-group size="sm" prepend="Traslado" class="mt-3">
          <b-form-select
            size="sm"
            v-model="$v.form.traslado.$model"
            :state="$v.form.traslado.$dirty ? !$v.form.traslado.$error : null"
            :options="trasladoOptions"
          ></b-form-select>
        </b-input-group>
        <b-input-group size="sm" prepend="Chofer" class="mt-3">
          <b-form-input
            autocomplete="off"
            size="sm"
            type="text"
            v-model="$v.form.documentTruckDriver.$model"
            :state="$v.form.documentTruckDriver.$dirty ? !$v.form.documentTruckDriver.$error : null"
            id="name"
            placeholder="Ingrese el nombre del chofer"
          />
        </b-input-group>
        <b-input-group size="sm" prepend="Rut Chofer" class="mt-3">
          <b-form-input
            autocomplete="off"
            size="sm"
            type="text"
            v-model="$v.form.documentTruckDriverRut.$model"
            :state="$v.form.documentTruckDriverRut.$dirty ? !$v.form.documentTruckDriverRut.$error : null"
            id="name"
            placeholder="Ingrese el rut del chofer"
          />
        </b-input-group>
        <b-input-group size="sm" prepend="Pantente" class="mt-3">
          <b-form-input
            autocomplete="off"
            type="text"
            size="sm"
            v-model="$v.form.documentLicensePlate.$model"
            :state="$v.form.documentLicensePlate.$dirty ? !$v.form.documentLicensePlate.$error : null"
            id="name"
            placeholder="Ingrese la placa"
          />
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group>
          <label class="font-weight-bold" for="name">Nota del documento</label>
          <b-form-textarea
            autocomplete="off"
            type="text"
            size="sm"
            v-model="form.documentNote"
            id="name"
            placeholder="Ingrese la nota del documento"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import V2Select from "../reusable/V2Select.vue";
import CreateSucursal from "./CreateSucursal.vue";
export default {
  props: {
    form: {
      type: Object
    }
  },
  components: {
    V2Select,
    CreateSucursal
  },
  data() {
    return {
      loading: false,
      ready: false,
      waybillType: "",
      senderOptions: [{ text: "Cargando...", value: null }],
      receiverOptions: [{ text: "Cargando...", value: null }],
      clientCustomerOptions: [],
      trasladoOptions: [
        {
          value: 1,
          text: "Operacion constituya venta"
        },
        {
          value: 2,
          text: "Ventas por efectuar"
        },
        {
          value: 3,
          text: "Consignacion"
        },
        {
          value: 4,
          text: "Entrega gratuita"
        },
        {
          value: 5,
          text: "Traslados internos"
        },
        {
          value: 6,
          text: "Otros traslados no venta"
        },
        {
          value: 7,
          text: "Guias de devolución"
        }
      ],
      despachoOptions: [
        {
          value: 0,
          text: "Sin despacho"
        },
        {
          value: 1,
          text: "Retira el cliente"
        },
        {
          value: 2,
          text: "Entrega a cliente"
        },
        {
          value: 3,
          text: "Entrega a otras instalaciones del cliente"
        }
      ],
      sucursalOptions: []
    };
  },
  validations: {
    form: {
      documentNumber: {
        required
      },
      documentSenderCompany: {
        required
      },
      documentClientCustomer: {
        required
      },
      documentRecipientCompany: {
        required
      },
      documentDate: {
        required
      },
      documentArrivalDatetime: {
        required
      },
      documentLicensePlate: {
        required
      },
      documentTruckDriver: {
        required
      },
      documentTruckDriverRut: {
        required
      },
      sucursal: {
        required
      },
      traslado: {
        required
      },
      despacho: {
        required
      }
    }
  },
  methods: {
    formValid() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return false;
      }
      return true;
    },
    handleSucursalSuccess(event) {
      this.sucursalOptions.push({
        value: event,
        text: event.name
      });
      this.form.sucursal = event;
    },
    async getSucursal(companyId) {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/v1/office/?no_page&company=${companyId}`);
        response.data.forEach((sucursal) => {
          this.sucursalOptions.push({
            value: sucursal,
            text: sucursal.name
          });
        });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$toasted.error("Error al obtener las sucursales");
      }
    }
  },
  watch: {
    "form.documentRecipientCompany": function (val) {
      if (val) {
        this.getSucursal(val.id);
      }
    }
  },
  async mounted() {
    this.ready = false;
    this.loading = true;
    this.senderOptions = [];
    this.receiverOptions = [];
    let companyOptions = [];
    let warehouseOptions = [];
    let departmentOptions = [];
    try {
      const response = await this.$axios({
        method: "GET",
        url: "api/v1/company/?no_page",
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      for (let item of response.data) {
        const optionData = {
          text: item.company_number + " - " + item.company_name,
          value: item.id,
          ...item
        };
        companyOptions.push(optionData);
      }
    } catch (error) {
      console.log(error);
      this.loading = false;
    }

    // Get Warehouses
    try {
      const response = await this.$axios({
        method: "GET",
        url: "api/v1/company/warehouses/?no_page",
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      for (let item of response.data) {
        const optionData = {
          text: item.company_number + " - " + item.company_name,
          value: item.id,
          ...item
        };
        warehouseOptions.push(optionData);
      }
    } catch (error) {
      console.log(error);
      this.loading = false;
    }

    // Get Departments
    try {
      const response = await this.$axios({
        method: "GET",
        url: "api/v1/company/departments/?no_page",
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      for (let item of response.data) {
        const optionData = {
          text: item.company_number + " - " + item.company_name,
          value: item.id,
          ...item
        };
        departmentOptions.push(optionData);
      }
    } catch (error) {
      console.log(error);
      this.loading = false;
    }

    // Get client_customer_options
    try {
      const response = await this.$axios({
        method: "GET",
        url: "production/get_customers/",
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.clientCustomerOptions = response.data.data;
      this.$emit("ready");
    } catch (error) {
      console.log(error);
      this.loading = false;
      this.$emit("ready");
    }

    if (this.$route.meta.label === "Ingreso") {
      this.senderOptions = companyOptions;
      this.receiverOptions = warehouseOptions;
    } else if (this.$route.meta.label === "Despacho") {
      this.senderOptions = warehouseOptions;
      this.receiverOptions = companyOptions;
    } else {
      this.senderOptions = departmentOptions;
      this.receiverOptions = departmentOptions;
    }
    this.ready = true;
  }
};
</script>

<style></style>
